import { render, staticRenderFns } from "./text_left_vid_no_thumb.vue?vue&type=template&id=f64b4516&scoped=true&"
import script from "./text_left_vid_no_thumb.vue?vue&type=script&lang=js&"
export * from "./text_left_vid_no_thumb.vue?vue&type=script&lang=js&"
import style0 from "./text_left_vid_no_thumb.vue?vue&type=style&index=0&id=f64b4516&scoped=true&lang=css&"
import style1 from "./text_left_vid_no_thumb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b4516",
  null
  
)

component.options.__file = "text_left_vid_no_thumb.vue"
export default component.exports